var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('link-input',{attrs:{"errors":_vm.errors.link},model:{value:(_vm.item.link),callback:function ($$v) {_vm.$set(_vm.item, "link", $$v)},expression:"item.link"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }